<template>
  <div class="intro">
    <div class="top">
      <img class="logo" @click="$router.push({ path: '/' })" :src="require('../../assets/img/introduce/logo.png')" />
      <div class="flex a-center w-600">
        <div class="item" @click="$router.push({ path: '/' })">首页</div>
        <div class="item" @click="$router.push({ path: '/aboutUs' })">关于我们</div>
        <div class="item" @click="$router.push({ path: '/webC' })">项目介绍</div>
        <div class="item"  @click="$router.push({ path: '/contact' })">联系我们</div>
      </div>
    </div>
    <div class="banner1">
      <div class="topmid">
        <img class="logo2" :src="require('../../assets/img/introduce/logo2.png')" />
        <div class="topItem">遂州出行</div>
      </div>
    </div>
    <div class="title" style="margin-top: 137px;">
      遂州出行是一个安全、高品质的出行服务平台，为用户提供安全、便捷、舒适的高品质一站式出行解决方案。
    </div>
    <div class="title" style="margin-bottom: 141px;">
      主要经营内容：客户直接线上呼叫出租车，客户的行程展示分享，是一个安全、高品质的出行服务平台，提供巡游出租车在线预约/呼叫/支付、出行交通行程信息展示等服务。</div>

    <div class="cardItem">
      <div class="tit"> 01 - 用户线上打车</div>
      <div class="flex a-center">
        <img class="img1" :src="require('../../assets/img/introduce/img1.png')" />
        <img class="img2" :src="require('../../assets/img/introduce/img2.png')" />
      </div>
    </div>
    <div class="cardItem">
      <div class="tit"> 02 - 司机入驻</div>
      <div class="flex a-center">
        <img class="img1" :src="require('../../assets/img/introduce/img3.png')" />
        <img class="img2" :src="require('../../assets/img/introduce/img4.png')" />
      </div>
    </div>
    <div class="cardItem">
      <div class="tit">03 - 司机接单</div>
      <div class="flex a-center">
        <img class="img1" :src="require('../../assets/img/introduce/img5.png')" />
        <img class="img2" :src="require('../../assets/img/introduce/img6.png')" />
      </div>
    </div>
    <div class="qrcode">
      <img class="qrcodeImg" :src="require('../../assets/img/introduce/downlod.png')" />
    </div>
    <div class="titleBtn">扫描二维码下载 四川联裕科技</div>
    <div class="footer">
      <div class="company">四川联裕科技信息有限公司</div>
      <div class="beian" @click="openUrl('https://beian.miit.gov.cn/#/Integrated/index')">
        蜀ICP备2024044808号-4
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    openUrl(url) {
      window.open(url);
    }
  },
};
</script>
<style scoped lang='less'>
.intro {
  position: relative;
}

.top {
  width: 100%;
  height: 153px;
  background: rgba(12, 21, 27, 0.6);
  // opacity: 0.6;
  padding: 0 121px 0 136px;
  position: fixed;
  top: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .w-600 {
    width: 600px;
    justify-content: space-between;
  }

  .item {
    height: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 21px;
    color: #FFFFFF;
    line-height: 29px;
    cursor: pointer;
  }

}

.logo {
  width: 231px;
  height: 101px;
}

.banner1 {
  margin-top: 153px;
  width: 100%;
  height: 900px;
  position: relative;
  background-size: cover;
  /* 调整背景图片大小以适应容器 */
  background-position: center;
  /* 将背景图片居中显示 */
  background-repeat: no-repeat;
  /* 避免背景图片重复 */
  background-image: url('../../assets/img/introduce/banner.png');
}

.logo2 {
  width: 201px;
  height: 201px;

}

.topmid {
  position: absolute;
  top: 290px;
  left: 40%;
  right: 40%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.topItem {
  height: 70px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 75px;
  color: #FFFFFF;
  line-height: 100px;
  opacity: 0.93;
  margin-top: 48px;
}

.title {
  margin: 0 auto;
  width: 1065px;
  // height: 332px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 33px;
  color: #282828;
  line-height: 75px;
  text-indent: 2em
}

.cardItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 167px;

  .tit {
    width: 490px;
    height: 86px;
    background: #05E1D1;
    border-radius: 20px;
    text-align: center;

    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 50px;
    color: #000000;
    line-height: 86px;
    margin-bottom: 74px;
  }

  .img1 {
    width: 616px;
    height: 1290px;
    margin-right: 129px;
  }

  .img2 {
    width: 616px;
    height: 1290px;
    // margin-right: 129px;
  }
}

.qrcode {
  width: 600px;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 22px;
  background: #05E1D1;
  border-radius: 30px;

  .qrcodeImg {
    width: 556px;
    height: 556px;
    background: #666666;
    border-radius: 30px;
  }
}

.titleBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 31px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 33px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 52px;
  margin-bottom: 140px;
  margin-top: 38px;
}

.footer {
  padding-top: 50px;
  padding-bottom: 51px;
  width: 100%;
  background-color: rgba(39, 39, 39, 1);
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 21px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}


.flex {
  display: 'flex';
}

.a-center {
  align-items: center;
}
</style>